module.exports = __webpack_public_path__ + "static/media/reservation.30d373c0.svg";